import { customEmailConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { sendCustomMailLoading: true, data: '', error: false };

export function sendCustomMailReducer(state = initialState, action) {

    switch (action.type) {
        case customEmailConstants.REQUEST_CUSTOM_MAIL:
            return {
                sendCustomMailLoading: true,
                data: '',
                error: false
            };
        case customEmailConstants.RECIEVE_CUSTOM_MAIL:
        swal({
            text: "Email sent Successfully!",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                sendCustomMailLoading: false,
                data: action.sendCustomMail,
                error: false
            };
        case customEmailConstants.ERROR_CUSTOM_MAIL:
            return {
                sendCustomMailLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/customEmails/sendCustomMail.reducer.js